/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Subtitle_Import_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Importing subtitle events failed: {error}" |
*
* @param {Subtitle_Import_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_failed_toast = /** @type {((inputs: Subtitle_Import_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de l'importation des evenements de sous-titres : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Importieren von Untertitelereignissen fehlgeschlagen: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Importazione degli eventi dei sottotitoli non riuscita: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось импортировать события субтитров: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al importar eventos de subtítulos: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`导入字幕事件失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`字幕イベントのインポートに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`उपशीर्षक इवेंट आयात करने में विफलता: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A importação de eventos de legenda falhou: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Importing subtitle events failed: ${i?.error}`)
});